require('jssocials');

/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */
$(function () {
    'use strict';

    $('#shareRoundIcons').jsSocials({
        shareIn: 'popup',
        showLabel: false,
        showCount: false,
        shares: [
            {
                share: 'twitter',
                logo: '/images/icons/twitter.svg',
            },
            {
                share: 'facebook',
                logo: '/images/icons/facebook.svg',
            },
            {
                share: 'linkedin',
                logo: '/images/icons/linkedin.svg',
            },
        ],
    });
});
